import { Grid, useMediaQuery } from '@mui/material';
import React, { useContext, useEffect } from 'react';
import globalStyles from "../../../assets/styles/global.module.scss";
import styles from "../../../assets/styles/componentStyles/intentStyles/intentStyle.module.scss";
import GlobalButton from '../../utility/globalButton/button';
import AddIcon from '@mui/icons-material/Add';
import { useIntentStore } from '../../../store/intentStore';
import IntentTable from './intentTable';
import { UserContext, UserContextPayload } from '../../../context/userContext';
import agent from '../../../services/api';
import GlobalSearch from '../../utility/GlobalSearch/GlobalSearch';
import { intent } from '../../../models/axiosModel';

const Intent = () => {

    const { setFlagLoading, handleError } = useContext(UserContext) as UserContextPayload
    const getAnalyticsIntentApiCall = useIntentStore((state) => state.getAnalyticsIntentApiCall);
    const intentDataList = useIntentStore((state) => state.intentDataList);
    const setFilteredIntentDataList = useIntentStore((state) => state.setFilteredIntentDataList);

    const breakPoints = {
        smallScreen: useMediaQuery<boolean>('(max-width : 600px) and (min-width : 0px)'),
    }

    const getAnalyticsIntentApi = async () => {
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: true }));
        const res = await getAnalyticsIntentApiCall();
        if(!(res.status)){
            handleError(res);
        }
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: false }));
    }

    useEffect(() => {
        getAnalyticsIntentApi();
    }, []);

    const mapAndFilterValidIntents = (intents: intent[] | null | undefined, filterFunc: (item: intent) => intent | null): intent[] => {
        return (intents ?? []).map(filterFunc).filter((item): item is intent => item !== null);
    };

    const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
        const query = e?.target?.value?.toLowerCase();
        if (intentDataList) {
            const filterRecursive = (intent: intent): intent | null => {
                const nameMatches = intent?.intent_name?.toLowerCase()?.includes(query);
                const filteredChildren = mapAndFilterValidIntents(intent.child_intent, filterRecursive);

                if (nameMatches) {
                    return { ...intent };
                }

                if (filteredChildren.length > 0) {
                    return { ...intent, child_intent: filteredChildren };
                }

                return null;
            };
            const filteredData = mapAndFilterValidIntents(intentDataList, filterRecursive);
            setFilteredIntentDataList(filteredData);
        }
    }

    return (
        <>
            <Grid container gap={2} direction={"column"}>
                <Grid item xs={12}>
                    <Grid container justifyContent={breakPoints.smallScreen ? "start" : "end"}>
                        <GlobalSearch
                            fullWidth
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => { handleSearch(e) }}
                            size="small"
                            placeholder="Search"
                        />
                    </Grid>
                </Grid>
                <Grid item xs={12} className={globalStyles.fullwidth}>
                    <IntentTable getAnalyticsIntentApi={getAnalyticsIntentApi} />
                </Grid>
            </Grid>
        </>
    )
}

export default Intent
